import { render, staticRenderFns } from "./batchReceive.vue?vue&type=template&id=5149d62c&"
import script from "./batchReceive.vue?vue&type=script&lang=js&"
export * from "./batchReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports